import { isArray } from 'lodash';
import React from 'react';
import Helper from './Helper';

class FormOrderBy extends React.Component {
    handleOrderBy = (e)=>{
        let name = e.target.name,
        value = e.target.value,
        {inputFilter} = this.props;
        inputFilter = inputFilter && isArray(inputFilter) ? inputFilter : [];
        let idx = inputFilter.findIndex((item)=>Object.keys(item)[0] === name);
        idx === -1 ? inputFilter.push({[name]:value}):inputFilter[idx][name] = value;
        this.props.handleOnChange(inputFilter);
    }
    handleChangeKeyword=(e)=>{
        let {value} = e.target;
        this.props.handleChangeKeyword(value);
    }
    handleResetFilterSearch = ()=>{
        this.props.handleResetFilterSearch();
    }
    handleSearchForm = (e)=>{
        e.preventDefault();
        let searchText = e.target.search_text.value;
        this.props.handleSearchForm(searchText);
    }
    render(){
        let {searchValues} = this.props,
        sortParam = Helper.getUrlParam('sort'),
        limitParam = Helper.getUrlParam('limit'),
        classMobile = 'form-control-sm',
        pageOptions = [
            {value:"12",text:"12 Sản phẩm"},
            {value:"24",text:"24 Sản phẩm"},
            {value:"48",text:"48 Sản phẩm"},
        ],
        sortOptions = [
            {value:"newest",text:"Mới nhất"},
            {value:"price_asc",text:"Giá thấp đến cao"},
            {value:"price_desc",text:"Giá cao đến thấp"}
        ],
        selectSortGenerate = sortOptions.map((option, index)=>{
            return <option key={index} value={option.value}>{option.text}</option>
        }),
        selectPageGenerate = pageOptions.map((option, index)=>{
            return <option key={index} value={option.value}>{option.text}</option>
        });
        
        let listViews = searchValues ? searchValues.map((item,index)=><li key={index}><a href={item.url}>{item.name}</a></li>):null;
        
        return (
            <form className="form-inline" onSubmit={this.handleSearchForm}>
                
                <div className="form-group mb-2 mr-2 position-relative">
                    <input id="input-custom-search" type="text" className={`form-control ${classMobile}`} 
                    placeholder="Nhập tên tác giả ..." onChange={this.handleChangeKeyword} />
                    {searchValues ? 
                    <button onClick={this.handleResetFilterSearch} type="button" className="btn btn-sm text-danger icon-close-input">
                        <i className="fas fa-times"/>
                    </button>
                    :null}
                    <ul className="position-absolute search_list_page text-sm" style={{display:'block'}}>
                        {listViews}
                    </ul>
                    
                </div>
                <div className="d-none d-md-flex form-group mb-2 ml-4 mr-2">
                    <label className="mr-2 d-none d-lg-block">Sắp xếp</label>
                    <select defaultValue={sortParam} name="sort" onChange={this.handleOrderBy} className={`form-control ${classMobile}`}>
                        {selectSortGenerate}
                    </select>
                </div>
                <div className="d-none d-md-flex form-group mx-sm-3 mb-2">
                    <label className="sr-only">Page</label>
                    <select defaultValue={limitParam} name="limit" onChange={this.handleOrderBy} className={`form-control ${classMobile}`}>
                        {selectPageGenerate}
                    </select>
                </div>
                
            </form>
        )
    }
}
export default FormOrderBy